export default __webpack_public_path__ + "static/7-36fc7b502b005f5b4796ee6998eb0ccc.png";